import { Chip } from "@bcc-ui/ui-components";
import classNames from "classnames";
import { t } from "i18next";
import React from "react";

import style from "./feature-badge.scss";

import testIds from "testIds.json";

interface Props {
    variant: "Beta" | "New";
    href?: string;
    isSmall?: boolean;
}

const VARIANT_TRANSLATION_KEYS: Record<Props["variant"], string> = {
    New: "Common.new",
    Beta: "Common.beta",
};

export const FeatureBadge = (props: Props) => {
    const chip = (
        <span data-testid={testIds.workArea.aiPanel.featureBadge} data-variant={props.variant}>
            <Chip
                className={classNames(style.featureBadge, {
                    [style.small]: props.isSmall,
                    [style.beta]: props.variant === "Beta",
                })}
            >
                {t(VARIANT_TRANSLATION_KEYS[props.variant])}
            </Chip>
        </span>
    );

    if (!props.href) {
        return chip;
    }

    return (
        <a
            href={props.href}
            target="_blank"
            rel="noopener noreferrer"
            className={style.featureBadgeLink}
            data-testid={testIds.workArea.aiPanel.featureBadge}
            data-variant={props.variant}
        >
            {chip}
        </a>
    );
};
